import { useState } from 'react';
import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              精彩预告
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              最新影片预告和幕后花絮，一睹为快
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {mediaItems.map((item, idx) => (
              <MediaCard key={idx} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function MediaCard({ item }: { item: (typeof mediaItems)[number] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer transition-all duration-300 hover:-translate-y-1">
      <div className="relative aspect-video overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-background-200">
            <i className="ri-play-circle-line text-4xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
        <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-xs px-2 py-0.5 rounded">
          {item.duration}
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2">{item.title}</h3>
        <div className="flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-eye-line"></i>
          <span>{item.views} 次播放</span>
        </div>
      </div>
    </div>
  );
}